import styled from "styled-components/macro";

import { MixinStyledInput } from "components/Input/styles";

export const PopupSelect = styled.div`
    position: absolute;
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    border: 1px solid ${(props) => props.theme.colors.border};
    background-color: ${(props) => props.theme.colors.place};
    opacity: 0;
    transition: 0.7s;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
    &.active {
    opacity: 1;
    }
    right: 0;
    width: 100%;
    z-index: 40;
    top: calc(100% + 0.2em);
`;

export const ItemsMultiSelectSearch = styled.input`
    ${MixinStyledInput}
    padding: 0.4em;
    background: none;
    width: 100%;
    border: none;
    box-shadow: none;
    display: inline-block;
    outline: none;
    &:focus {
    outline: none;
    }
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }
    &[type="number"] {
    -moz-appearance: textfield;
    }
 `;
